import { render, staticRenderFns } from "./BookingActivityForm.vue?vue&type=template&id=52430a8b"
import script from "./BookingActivityForm.vue?vue&type=script&lang=js"
export * from "./BookingActivityForm.vue?vue&type=script&lang=js"
import style0 from "./BookingActivityForm.vue?vue&type=style&index=0&id=52430a8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports